import { render } from "./PartnersCertificates.vue?vue&type=template&id=e60a1e74&scoped=true"
import script from "./PartnersCertificates.vue?vue&type=script&lang=js"
export * from "./PartnersCertificates.vue?vue&type=script&lang=js"

import "./PartnersCertificates.vue?vue&type=style&index=0&id=e60a1e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60a1e74"]])

export default __exports__